import { toast } from '@/helpers/toast/toast.helper'
import { AxiosResponse } from 'axios'
import { put } from 'redux-saga/effects'
import { addParticipantToGroupAction } from '../../handles'
import { zApiMultiService } from '@/services/api'
import { addParticipants } from '../_http/groups'

export function* addParticipantToGroupSaga(action: ReturnType<typeof addParticipantToGroupAction.request>) {
  const { activeChat, phones, campaign, callBack } = action.payload
  try {
    const url = `/instances/campanhaId/${campaign.id}/token/${campaign.token}/add-participant`
    const addParticipantResponse: AxiosResponse = yield zApiMultiService.post(url, {
      groupId: activeChat.phone,
      phones
    })

    if (addParticipantResponse.data?.value) {
      const { participants } = activeChat
      phones.forEach(phone => {
        participants.push({
          lid: phone,
          phone,
          isAdmin: false,
          isSuperAdmin: false
        })
      })
      yield addParticipants(activeChat.id, phones, activeChat.ownerId)
      toast({ type: 'success', message: `Contato(s) adicionado(s) com sucesso` })
      yield put(addParticipantToGroupAction.success({ updatedChatData: { participants } }))
      callBack?.()
    } else {
      toast({ type: 'error', message: 'Não foi possível adicionar contato(s), tente novamente' })
      yield put(addParticipantToGroupAction.failure(null))
    }
  } catch (error) {
    toast({ type: 'error', message: 'Erro ao adicionar contato(s) no grupo' })
    console.log({ addParticipantToGroupSagaError: error })
    yield put(addParticipantToGroupAction.failure(error))
  }
}
